import { Component } from '@angular/core';

@Component({
    selector: 'app-connection-error',
    templateUrl: './connection-error.html',
    styleUrls: ['./connection-error.component.scss'],
    standalone: false
})
export class ConnectionErrorComponent {}